/****************************************************
 * Module Name:  cancelSale.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { forwardRef, Component } from "react"
import CommonSnackbar from "../common/commonSnackBar";
import CancelSaleModal from "./cancelSaleModal";
import Constants from "../../utility/constants";
import Utility from "../../utility/utility";
import { Box, Button, Tooltip, TextField, ThemeProvider, Typography, createTheme, Stack, } from "@mui/material";
import { DataGridPro, GridToolbar, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LoadingButton } from "@mui/lab";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Cancel from "@mui/icons-material/Cancel";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import EditIcon from "@mui/icons-material/Edit";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import FilterListIcon from "@mui/icons-material/FilterList";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import RemoveIcon from "@mui/icons-material/Remove";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import { BsFilePdf } from "react-icons/bs";
import Select from "react-select";

import StoneProxy from "../../utility/proxy/manager/stoneProxy";
import NoPermission from "../common/noPermission";
import PDFModal from "../common/pdfModal";
import SalesProxy from "../../utility/proxy/manager/reportSalesProxy";
import dayjs from "dayjs";
import renderCellExpand from "../common/dataGridCellExpand";

import { styled } from "@mui/material/styles";
import PageTitle from "../common/pageTitle";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    '& .super-app-theme--Paid': {
        color: 'green',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    '& .super-app-theme--PartiallyPaid': {
        color: 'orange',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
    },
    '& .super-app-theme--Unpaid': {
        color: '#000',
        fontWeight: 'normal',
        whiteSpace: 'nowrap',
    },
}));


export default class CancelSale extends Component {
    constructor(props) {
        super(props);

        let fDt = new Date();
        let tDt = new Date();

        this.state = {
            fromDate: new Date(fDt.setDate(fDt.getDate() - 1)),
            toDate: tDt,

            invoice: [],
            invoiceSelection: {},

            user: [],
            selectedUser: [],

            filterValues: {},

            invoiceLoading: false,

            showSuccessSnackbar: false,
            successMessage: "",
            snackbarVariant: "",

            cancelInvoiceSaleModalShow: false,
            cancelStoneSaleModalShow: false,
            selectedInvoice: 0,
            selectedStoneIds: [],
            local_Permission: Constants.USER_PERMISSION.filter(
                (iPermission) =>
                    iPermission.permissionid === Constants.PERMISSIONS.SALES_CANCEL_SALE
            ),
            pdfName: "",
            pdfByte: "",
            isModalOpen: false,
            data: "",
            warning: false,
            warningmessage: "",

            totalInvoice: 0,
            totalAmountUSD: 0,
            totalAmountINR: 0,
            pendingAmountUSD: 0,
            pendingAmountINR: 0,
            paidAmountUSD: 0,
            paidAmountINR: 0,
            showUserDetailModal: false
        }
        this.getAllUserData();
    }

    defaultMaterialTheme = createTheme();

    componentDidMount() {
        PageTitle("SALES_CANCEL_SALE");
    }

    openModal = () => {
        this.setState({
            isModalOpen: true,
        })
    };

    closeModal = () => {
        this.setState({
            isModalOpen: false,
        })
    };

    getAllUserData = () => {

        SalesProxy.GetCustomersCreatedInvoice(
            Constants.loggedInUser.locationid,
            -1,
            Constants.loggedInUser.usertype,
            (response) => {
                if (response) {
                    this.setAllUserData(response);
                } else {
                    this.setState({
                        showSuccessSnackbar: true,
                        successMessage: Constants.APiFailErrorMessage,
                        snackbarVariant: "error",
                    })
                }
            }
        );
    };

    downloadPDF = (invoiceid, fileBytes) => {
        this.setState({
            pdfByte: fileBytes,
            pdfName: (`Invoice` + invoiceid + `.pdf`),
        })
        this.openModal()
    }

    setAllUserData = (response) => {
        let newUsers = [];
        newUsers.push({ value: "*", label: "-- ANY --" });

        response.map((data) => newUsers.push({
            value: data.id,
            label: data.companyname,
        }));

        this.setState({
            user: newUsers,
            selectedUser: [newUsers[0]]
        })
    };

    fullOptionToValue = (selectedData, mainData) => {

        let newArr = [];
        selectedData.map((data) => {
            if (data.value === "*") {
                return (mainData.map((option) => {
                    if (option.value !== "*") {
                        newArr.push(option.value);
                        return true;
                    }
                    return true;
                }));
            }
            return true;
        })
        return Utility.GetValueArrayWithStarReplace(selectedData, newArr);
    };

    summaryData = (data) => {
        if (!Array.isArray(data)) return;
        let totalInvoice = data.length;

        let tAmountINR = 0;
        let pendingAmountINR = 0;
        let paidAmountINR = 0;

        let tAmount = 0;
        let pendingAmount = 0
        let paidAmount = 0;

        data.forEach((item) => {
            if (item.exchangecurrency === "USD") {
                tAmount += item.finalpayableamount;
                pendingAmount += item.finalpayableamount - item.amountpaid;
                paidAmount += item.amountpaid
            } else {
                tAmountINR += item.finalpayableamount;
                pendingAmountINR += item.finalpayableamount - item.amountpaid;
                paidAmountINR += item.amountpaid
            }
        });

        return [
            totalInvoice,
            tAmount,
            tAmountINR,
            pendingAmount,
            pendingAmountINR,
            paidAmount,
            paidAmountINR
        ];
    };

    setSummaryData = (data) => {
        const [
            totalInvoice,
            tAmount,
            tAmountINR,
            pendingAmount,
            pendingAmountINR,
            paidAmount,
            paidAmountINR
        ] = this.summaryData(data);

        this.setState({
            totalInvoice: totalInvoice,
            totalAmountUSD: tAmount,
            totalAmountINR: tAmountINR,
            pendingAmountUSD: pendingAmount,
            pendingAmountINR: pendingAmountINR,
            paidAmountUSD: paidAmount,
            paidAmountINR: paidAmountINR
        });
    }

    handleSearch = () => {
        this.setState({ invoiceLoading: true });
        let users = this.fullOptionToValue(this.state.selectedUser, this.state.user);
        let stoneids = this.state.data.split(",").filter(Boolean).map(Number);

        let data = {
            from: Utility.ConvertLocalTimeToUtc(this.state.fromDate).slice(0, 11) + "00:00:00.000Z",
            to: Utility.ConvertLocalTimeToUtc(this.state.toDate).slice(0, 11) + "23:59:59.999Z",
            users: users,
            status: ["PAID", "UNPAID"],
            stoneids: stoneids,
            locationid: Constants.loggedInUser.locationid,
        };

        StoneProxy.GetAllInvoices("U", data, (response) => {
            if (response) {
                const uniqueFilterValues = {
                    exchangecurrency: Utility.getDistinctOptions(response, "exchangecurrency"),
                    user: Utility.getDistinctOptions(response, "userid"),
                    broker: Utility.getDistinctOptions(response, "brokerid"),
                    customer: Utility.getDistinctOptions(response, "customerid"),
                    tradingcompany: Utility.getDistinctOptions(response, "tradingcompanyid"),
                };
                const combinedFilterValues = {
                    exchangecurrency: uniqueFilterValues.exchangecurrency,
                    user: uniqueFilterValues.user.map(value => {
                        const matchingItem = response.find(item => item.userid === value);
                        return matchingItem ? `${value} | ${matchingItem.username}` : [];
                    }),
                    broker: uniqueFilterValues.broker.map(value => {
                        const matchingItem = response.find(item => item.brokerid === value);
                        if (matchingItem) {
                            let displayValue = matchingItem.brokerid === -1 ? " - " : `${matchingItem.brokerid} | ${matchingItem.brokercompanyname}`;
                            return displayValue;
                        }
                        return [];
                    }),
                    customer: uniqueFilterValues.customer.map(value => {
                        const matchingItem = response.find(item => item.customerid === value);
                        return matchingItem ? `${value} | ${matchingItem.customercompanyname}` : [];
                    }),
                    tradingcompany: uniqueFilterValues.tradingcompany.map(value => {
                        const matchingItem = response.find(item => item.tradingcompanyid === value);
                        return matchingItem ? `${value} | ${matchingItem.tradingcompanyname}` : [];
                    }),
                };
                this.setState({
                    invoice: response,
                    invoiceLoading: false,
                    invoiceSelection: {},
                    filterValues: combinedFilterValues,
                });
                this.setSummaryData(response);
            } else {
                this.setState({
                    invoiceLoading: false,
                    showSuccessSnackbar: true,
                    successMessage: Constants.APiFailErrorMessage,
                    snackbarVariant: "error",
                    invoiceSelection: {},
                });
            }
        });
    }

    stoneTableColumn = [
        {
            field: "stonedetail.stoneid",
            headerName: "STONE ID",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "number",
            valueFormatter: (params) => params.value,
            valueGetter: (params) => params.row.stonedetail.stoneid,
        },
        {
            field: "stonedetail.status",
            headerName: "STATUS",
            headerAlign: "center",
            align: "center",
            width: 100,
            valueGetter: (params) => params.row.status,
        },
        {
            field: "stonedetail.stonetype",
            headerName: "STONETYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.row.stonedetail.stonetype],
            renderCell: (params) => Constants.STONE_TYPE[params.row.stonedetail.stonetype],
        },
        {
            field: "stonedetail.size",
            headerName: "SIZE",
            headerAlign: "center",
            align: "right",
            width: 40,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: (params) => Utility.ConvertNumberWithSpecifiedDigits(params.row.stonedetail.size),
        },
        {
            field: "stonedetail.color",
            headerName: "COLOR",
            headerAlign: "center",
            align: "center",
            width: 65,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.color.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.color,
        },
        {
            field: "stonedetail.colordescriptions",
            headerName: "COLOR DESCRIPTIONS",
            headerAlign: "center",
            align: "center",
            width: 160,
            renderCell: renderCellExpand,
            valueGetter: (params) => params.row.stonedetail.colordescriptions,
        },
        {
            field: "stonedetail.shape",
            headerName: "SHAPE",
            headerAlign: "center",
            align: "center",
            width: 80,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.shape.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.shape,
        },
        {
            field: "stonedetail.cut",
            headerName: "CUT",
            headerAlign: "center",
            align: "center",
            width: 50,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.cut.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.cut,
        },
        {
            field: "stonedetail.clarity",
            headerName: "CLARITY",
            headerAlign: "center",
            align: "center",
            width: 75,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.clarity.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.clarity,
        },
        {
            field: "stonedetail.pol",
            headerName: "POL",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.pol.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.pol,
        },
        {
            field: "stonedetail.sym",
            headerName: "SYM",
            headerAlign: "center",
            align: "center",
            width: 40,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.sym.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.sym,
        },
        {
            field: "stonedetail.flo",
            headerName: "FLO",
            headerAlign: "center",
            align: "center",
            width: 60,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.flo.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.flo,
        },
        {
            field: "stonedetail.certificateid",
            headerName: "CERTIFICATEID",
            headerAlign: "center",
            align: "center",
            width: 120,
            type: "number",
            valueFormatter: (params) => params.value,
            valueGetter: (params) => params.row.stonedetail.certificateid,
        },
        {
            field: "stonedetail.colortype",
            headerName: "COLORTYPE",
            headerAlign: "center",
            align: "center",
            width: 100,
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.colortype.sort((a, b) => a.seq - b.seq).map(option => option.value),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => params.row.stonedetail.colortype,
        },
        {
            field: "stoneprice",
            headerName: "TOTAL",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
        },
        {
            field: "actualdiscount",
            headerName: "ACTUAL DIS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 110,
        },
        {
            field: "defaultdiscount",
            headerName: "DEFAULT DIS",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 100,
        },
        {
            field: "discountprice",
            headerName: "PPC",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
        },
        {
            field: "originalprice",
            headerName: "RAP",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 70,
        },
    ];

    initialColumns = () => [
        {
            headerName: "CANCEL SALE",
            field: "cancelsale",
            width: 160,
            headerAlign: "center",
            hide: Utility.isUpdateAllowed(this.state.local_Permission) || Utility.isDeleteAllowed(this.state.local_Permission) ? false : true,
            renderCell: (params) => (
                <Tooltip title="Cancel Sale">
                    <Button
                        variant="contained"
                        component="label"
                        size="small"
                        startIcon={<Cancel size="large" />}
                        color="primary"
                        onClick={() => {
                            let stoneIds = [];
                            params.row.stones.forEach(iStone => {
                                if (iStone.status !== "CANCELLED")
                                    stoneIds.push(iStone.stoneid)
                            })
                            if (stoneIds.length > 0) {
                                this.setState({
                                    cancelStoneSaleModalShow: true,
                                    selectedInvoice: params.row.id,
                                    selectedStoneIds: stoneIds
                                })
                            }
                        }}
                    >
                        Cancel Sale
                    </Button>
                </Tooltip>
            ),
        },
        {
            headerName: "INVOICE ID",
            field: "id",
            defaultSort: "desc",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 110,
        },
        {
            headerName: "STONETYPE",
            field: "stonetype",
            headerAlign: "center",
            align: "center",
            type: "singleSelect",
            valueOptions: Constants.uniqueFilterValues.stonetype.map(option => option.fullname),
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => Constants.STONE_TYPE[params.value],
            renderCell: (params) => Constants.STONE_TYPE[params.value],
            width: 90,
        },
        {
            headerName: "USER",
            field: "userid",
            type: "singleSelect",
            valueOptions: this.state.filterValues ? this.state.filterValues.user : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.userid} | ${params.row.username}`;
            },
            renderCell: (params) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                        {`${params.row.userid} | ${params.row.username}`}
                    </span>
                </div>
            ),
            headerAlign: "center",
            align: "center",
            width: 150,
        },
        {
            headerName: "BROKER COMPANY",
            field: "brokerid",
            type: "singleSelect",
            valueOptions: this.state.filterValues ? this.state.filterValues.broker : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.brokerid} | ${params.row.brokercompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {(params.row.brokerid === -1 || params.row.brokerid === null) ? " - " : `${params.row.brokerid} | ${params.row.brokercompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
            width: 185,
        },
        {
            headerName: "CUSTOMER COMPANY",
            field: "customerid",
            type: "singleSelect",
            valueOptions: this.state.filterValues ? this.state.filterValues.customer : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.customerid} | ${params.row.customercompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.customerid} | ${params.row.customercompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
            width: 225,
        },
        {
            headerName: "TRADING COMPANY",
            field: "tradingcompanyid",
            type: "singleSelect",
            valueOptions: this.state.filterValues ? this.state.filterValues.tradingcompany : [],
            filterOperators: Utility.combinedFilters(),
            valueGetter: (params) => {
                return `${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`;
            },
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span style={{ marginRight: '5px', marginLeft: '10px' }}>
                            {`${params.row.tradingcompanyid} | ${params.row.tradingcompanyname}`}
                        </span>
                    </div>
                );
            },
            headerAlign: "center",
            align: "center",
            width: 200,
        },
        {
            headerName: "EXCHANGE CURRENCY",
            field: "exchangecurrency",
            headerAlign: "center",
            align: "center",
            width: 170,
            type: "singleSelect",
            valueOptions: this.state.filterValues ? this.state.filterValues.exchangecurrency : [],
            filterOperators: Utility.combinedFilters(),
            renderCell: renderCellExpand
        },
        {
            headerName: "EXCHANGE RATE",
            field: "exchangerate",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 130,
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPING COST",
            field: "shippingcost",
            headerAlign: "center",
            align: "center",
            width: 110,
            type: "number",
            valueFormatter: (params) => params.value,
            renderCell: renderCellExpand
        },
        {
            headerName: "FINAL PAYABLE AMOUNT",
            field: "finalpayableamount",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 170,
            renderCell: renderCellExpand
        },
        {
            headerName: "PDF",
            field: "performapdf",
            renderCell: (params) => (
                <BsFilePdf size={25} color="red" onClick={() => this.downloadPDF(params.row.id, params.row.performapdf)} />
            ),
            export: false,
            width: 55,
            headerAlign: "center",
            align: "center",
        },
        {
            headerName: "PAID AMOUNT",
            field: "amountpaid",
            headerAlign: "center",
            align: "center",
            type: "number",
            valueFormatter: (params) => params.value,
            width: 110,
            renderCell: renderCellExpand
        },
        {
            headerName: "DATE",
            field: "date",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.row.date).split(' ')[0],
            type: "dateTime",
            headerAlign: "center",
            align: "center",
            width: 85,
        },
        {
            headerName: "EXPORT",
            field: "export",
            headerAlign: "center",
            align: "center",
            width: 65,
            renderCell: (params) =>
                params.row.export ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
        },
        {
            headerName: "COUNTRY OF FINAL DESTINATION",
            field: "countryoffinaldestination",
            headerAlign: "center",
            align: "center",
            width: 220,
            renderCell: renderCellExpand
        },
        {
            headerName: "COUNTRY OF ORIGIN",
            field: "countryoforigin",
            headerAlign: "center",
            align: "center",
            width: 145,
            renderCell: renderCellExpand
        },
        {
            headerName: "FINAL DESTINATION",
            field: "finaldestination",
            headerAlign: "center",
            align: "center",
            width: 135,
            renderCell: renderCellExpand
        },
        {
            headerName: "ENSURED BY",
            field: "ensuredby",
            headerAlign: "center",
            align: "center",
            width: 95,
            renderCell: renderCellExpand
        },
        {
            headerName: "BANK THROUGH",
            field: "bankthrough",
            renderCell: (params) =>
                params.row.bankthrough ? (
                    <CheckIcon color="success" />
                ) : (
                    <ClearIcon color="error" />
                ),
            headerAlign: "center",
            align: "center",
            width: 115,
        },
        {
            headerName: "PORT OF LOADING",
            field: "portofloading",
            headerAlign: "center",
            align: "center",
            width: 130,
            renderCell: renderCellExpand
        },
        {
            headerName: "SHIPPED BY",
            field: "shippedby",
            headerAlign: "center",
            align: "center",
            renderCell: renderCellExpand
        },
        {
            headerName: "PORT OF DISCHARGE",
            field: "portofdischarge",
            headerAlign: "center",
            align: "center",
            width: 150,
            renderCell: renderCellExpand
        },
        {
            headerName: "REMARKS",
            field: "remarks",
            headerAlign: "center",
            align: "center",
            width: 75,
            renderCell: renderCellExpand
        },
        {
            headerName: "TERMS",
            field: "terms",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: renderCellExpand
        },
        {
            headerName: "DAYS",
            field: "days",
            headerAlign: "center",
            align: "center",
            width: 60,
            renderCell: (params) => params.value,
        },
        {
            headerName: "DUE DATE",
            field: "duedate",
            type: "dateTime",
            valueGetter: (params) => {
                if (params.value) {
                    return new Date(params.value);
                }
                return null;
            },
            renderCell: (params) => Utility.ConvertUtcToLocalTime(params.row.duedate).split(' ')[0],
            headerAlign: "center",
            align: "center",
            width: 85,
        },
    ]

    updateState = (stateName, value) => {
        this.setState({ [stateName]: value })
    }

    getDetailPanelHeight() {
        return 'auto';
    }

    getDetailPanelContent(row) {
        return <this.DetailPanelContent row={row} state={this.state} stoneTableColumn={this.stoneTableColumn} updateState={this.updateState} />;
    }

    DetailPanelContent({ row: rowProp, state, stoneTableColumn, updateState }) {
        let row = rowProp.stones;

        let totalSize = 0;
        let totalPrice = 0;   //ppc*size
        let total = 0;       //rapnetprice*size

        row.forEach((iData) => {
            let pricePerCarat = iData.discountprice;
            totalSize += iData.size;
            totalPrice += (iData.size * pricePerCarat);
            total += (iData.size * ((100 * pricePerCarat) / (100 + iData.actualdiscount)));
        });

        let noOfSelectedStones = row.length;
        let selectedTotalSize = Utility.ConvertNumberWithSpecifiedDigits(totalSize);
        let selectedtotalPrice = Utility.ConvertNumberWithSpecifiedDigits(totalPrice);
        let selectedavgPrice = totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits(totalPrice / totalSize) :
            Utility.ConvertNumberWithSpecifiedDigits(0);
        let selectedAvgDiscount = totalPrice > 0 ?
            Utility.ConvertNumberWithSpecifiedDigits((100 - (totalPrice / total) * 100) * -1) :
            Utility.ConvertNumberWithSpecifiedDigits(0);

        return (
            <Stack
                sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
                direction="column"
            >
                <Box
                    sx={{
                        backgroundColor: '#fff',
                        color: '#000',
                        width: "85vw",
                        position: "relative",
                        "& .MuiTablePagination-selectLabel": {
                            marginTop: "15px",
                        },
                        "& .MuiTablePagination-displayedRows": {
                            marginTop: "15px",
                        },
                        "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                            color: "#1976d2",
                            padding: "4px 5px",
                            borderRadius: "4px",
                        },
                        "& .css-cc8tf1": {
                            fontWeight: Constants.defaultFontWeight,
                        },
                        height: 'auto',
                        marginLeft: '16px',
                    }}
                >
                    <DataGridPro
                        disableRowSelectionOnClick={false}
                        density="compact"
                        columns={stoneTableColumn}
                        rows={row}
                        getRowId={(row) => row.invoiceid + "_" + row.stonedetail.stoneid}
                        sx={{
                            '& .MuiDataGrid-columnHeader': {
                                color: '#fff',
                                backgroundColor: 'grey',
                            },
                            "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                py: "8px",
                            },
                            "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                py: "15px",
                            },
                            "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                py: "22px",
                            },

                            fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            maxHeight: '30vh',
                        }}
                        checkboxSelection={Utility.isUpdateAllowed(state.local_Permission) || Utility.isDeleteAllowed(state.local_Permission)}
                        onRowSelectionModelChange={(newSelectionModel) => {
                            let tempSelection = state.invoiceSelection;
                            tempSelection[rowProp.id] = newSelectionModel;
                            // this.setState({ invoiceSelection: tempSelection })
                            updateState("invoiceSelection", tempSelection)
                        }}
                        rowSelectionModel={state.invoiceSelection[rowProp.id]}
                        slots={{ toolbar: GridToolbar }}
                        slotProps={{
                            toolbar: {
                                showQuickFilter: true,
                                quickFilterProps: { debounceMs: 500 },
                            },
                        }}
                        hideFooter
                    />

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            width: '53%',
                            position: "absolute",
                            left: "500px",
                            top: "7px"
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: "black",
                                fontWeight: 'normal',
                                fontSize: Constants.defaultTableFontSize,
                            }}
                        ><p style={{
                            margin: 0
                        }}>
                                <span>No of Stones: </span> <b>{noOfSelectedStones}</b> &nbsp;&nbsp;|&nbsp;&nbsp;
                                <span>Total Weight: </span> <b>{selectedTotalSize}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                <span>Total Price: </span> <b>{selectedtotalPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                <span>Avg Price: </span> <b>{selectedavgPrice}</b>  &nbsp;&nbsp;|&nbsp;&nbsp;
                                <span>Avg Discount: </span> <b>{selectedAvgDiscount}</b></p>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            {Utility.isUpdateAllowed(state.local_Permission) ||
                                Utility.isDeleteAllowed(state.local_Permission) ?
                                <Tooltip title="Cancel Sale">
                                    <Button
                                        variant="contained"
                                        component="label"
                                        size="small"
                                        sx={{ ml: "5px" }}
                                        startIcon={<Cancel size="large" />}
                                        color="primary"
                                        disabled={state.invoiceSelection[rowProp.id] === undefined || state.invoiceSelection[rowProp.id].length <= 0}
                                        onClick={() => {
                                            let cancelledStone = null;

                                            // Iterate through the invoice selection
                                            for (const compositeStoneid of state.invoiceSelection[rowProp.id]) {
                                                const stoneid = compositeStoneid.split("_")[1];

                                                cancelledStone = rowProp.stones.find(iStone => {
                                                    return iStone.stoneid === Number(stoneid) && iStone.status === "CANCELLED";
                                                });

                                                if (cancelledStone) {
                                                    break;
                                                }
                                            }

                                            if (cancelledStone !== undefined) {
                                                // this.setState({
                                                //     warning: true,
                                                //     warningmessage: "The stone selected is already cancelled",
                                                // })
                                                updateState("warning", true);
                                                updateState("warningmessage", "The stone selected is already cancelled")
                                            } else {
                                                let newStoneids = [];
                                                state.invoiceSelection[rowProp.id].map((iStoneIds) => newStoneids.push(Number(iStoneIds.split("_")[1])));
                                                // this.setState({
                                                //     cancelStoneSaleModalShow: true,
                                                //     selectedInvoice: rowProp.id,
                                                //     selectedStoneIds: newStoneids,
                                                // });
                                                updateState("cancelStoneSaleModalShow", true);
                                                updateState("selectedInvoice", rowProp.id);
                                                updateState("selectedStoneIds", newStoneids);
                                            }
                                        }}
                                    >
                                        Cancel Sale
                                    </Button>
                                </Tooltip> : null}
                        </Box>
                    </Box>
                </Box>
            </Stack>
        );
    }



    invoiceTableIcons = {
        Add: forwardRef((props, ref) => <AddBoxIcon {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <CheckIcon {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <ClearIcon {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => (
            <DeleteOutlineIcon {...props} ref={ref} />
        )),
        DetailPanel: forwardRef((props, ref) => (
            <ChevronRightIcon {...props} ref={ref} />
        )),
        Edit: forwardRef((props, ref) => <EditIcon {...props} ref={ref} />),
        Export: forwardRef((props, ref) => (
            <div>
                <SaveAltIcon {...props} ref={ref} color="primary" fontSize="small" />
                Export
            </div>
        )),
        Filter: forwardRef((props, ref) => <FilterListIcon {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPageIcon {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPageIcon {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => (
            <ChevronRightIcon {...props} ref={ref} />
        )),
        PreviousPage: forwardRef((props, ref) => (
            <ChevronLeftIcon {...props} ref={ref} />
        )),
        Refresh: forwardRef((props, ref) => (
            <RefreshOutlinedIcon {...props} ref={ref} color="primary" />
        )),
        ResetSearch: forwardRef((props, ref) => <ClearIcon {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <SearchIcon {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => (
            <ArrowDownwardIcon {...props} ref={ref} />
        )),
        ThirdStateCheck: forwardRef((props, ref) => (
            <RemoveIcon {...props} ref={ref} />
        )),
        ViewColumn: forwardRef((props, ref) => (
            <div>
                <ViewColumnIcon {...props} ref={ref} color="primary" fontSize="small" />
                Columns
            </div>
        )),
    };

    handleCancelAllStoneSale = (invoiceId) => {
        let inv = this.state.invoice;
        if (inv && inv.length > 0) {
            inv.map((iInv) => {
                if (iInv.id === invoiceId) {
                    let stoneIds = [];
                    iInv.stones.map((iStone) => stoneIds.push(iStone.stoneid))

                    if (stoneIds.length > 0)
                        this.handleFireCancelCellApi(invoiceId, stoneIds);
                }
                return true;
            })
        }
    }

    handleFireCancelCellApi = (invoiceId, stoneIds) => {
        this.setState({ invoiceLoading: true });
        let data = {
            invoiceid: invoiceId,
            stoneids: stoneIds,
        }

        StoneProxy.CancelSale(data, (response) => {
            if (response) {

                this.setState({
                    showSuccessSnackbar: true,
                    successMessage: "Stone Sale is Cancelled",
                    snackbarVariant: "success",
                    invoiceLoading: false,
                    cancelInvoiceSaleModalShow: false,
                    cancelStoneSaleModalShow: false,
                });

                this.handleSearch();
            } else {
                this.setState({
                    showSuccessSnackbar: true,
                    successMessage: Constants.APiFailErrorMessage,
                    snackbarVariant: "error",
                    cancelInvoiceSaleModalShow: false,
                    cancelStoneSaleModalShow: false,
                    invoiceLoading: false,
                })
            }
        })
    }

    handleCancelSelectedStoneSale = (invoiceId, stoneIds) => {
        this.handleFireCancelCellApi(invoiceId, stoneIds);
    }

    render() {
        const CustomToolbar = () => {
            return (
                <GridToolbarContainer
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        marginHorizontal: "5px",
                        "&.MuiDataGrid-toolbarContainer": {
                            padding: "0px 4px !important",
                        },
                    }}
                >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarExport />
                    <Box sx={{ flexGrow: 1, display: { md: "none", lg: "block" } }} />
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexGrow: 1,
                            minWidth: 0,
                            px: 1,
                        }}
                    >
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            spacing={2}
                            useFlexGap
                            flexWrap="wrap"
                            sx={{
                                width: "100%",
                                alignItems: { xs: "flex-start", sm: "center" },
                                justifyContent: { xs: "flex-start", sm: "flex-start" },
                            }}
                        >
                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Total Invoice: <b>{this.state.totalInvoice}</b>
                            </Typography>

                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Total Amount USD: <b>{this.state.totalAmountUSD}</b>
                            </Typography>
                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Total Amount INR: <b>{this.state.totalAmountINR}</b>
                            </Typography>

                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Pending Amount USD: <b>{this.state.pendingAmountUSD}</b>
                            </Typography>
                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Pending Amount INR:<b>{this.state.pendingAmountINR}</b>
                            </Typography>
                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Paid Amount USD:<b>{this.state.paidAmountUSD}</b>
                            </Typography>
                            <Typography component="span" sx={{ fontSize: Constants.defaultTableFontSize }}>
                                Paid Amount INR:<b>{this.state.paidAmountINR}</b>
                            </Typography>
                        </Stack>
                    </Box>


                    {this.state.invoiceLoading ? (
                        <CircularProgress size="1rem" />
                    ) : (
                        <Tooltip title="Reload Invoice List">
                            <RefreshOutlinedIcon
                                onClick={() => {
                                    this.getAllUserData()
                                    this.handleSearch()
                                }}
                                color="primary"
                                fontSize="medium"
                                sx={{ cursor: "pointer" }}
                            />
                        </Tooltip>
                    )}
                    <GridToolbarQuickFilter debounceMs={500} />
                </GridToolbarContainer>
            );
        }
        let allowed = Utility.isReadAllowed(this.state.local_Permission)
        if (!allowed) {
            return <NoPermission />
        }
        return (
            <div>
                {/* {<CancelSaleModal
                    show={this.state.cancelInvoiceSaleModalShow}
                    setShow={(bShow) => this.setState({ cancelInvoiceSaleModalShow: bShow })}
                    handleSave={() => this.handleCancelAllStoneSale(this.state.selectedInvoice)}
                />} */}

                {<CancelSaleModal
                    show={this.state.cancelStoneSaleModalShow}
                    setShow={(bShow) => this.setState({ cancelStoneSaleModalShow: bShow })}
                    handleSave={() => this.handleCancelSelectedStoneSale(this.state.selectedInvoice, this.state.selectedStoneIds)}
                    loading={this.state.invoiceLoading}
                />}

                {this.state.showUserDetailModal ? (
                    <UserDetailModal
                        show={true}
                        handleClose={() => this.setState({ showUserDetailModal: false })}
                        handleSelect={(selectedOption) => {
                            const selectedCustomers = this.state.user.filter(opt =>
                                selectedOption.includes(opt.value)
                            );
                            this.setState({ selectedUser: selectedCustomers, showUserDetailModal: false })
                        }}
                        userids={this.state.user.filter(option => option.value !== "*").map(cust => cust.value)}
                        selectedIds={this.state.selectedUser.length !== 0 ? this.state.selectedUser.map(iCustomer => iCustomer.value) : []}
                        usertype={"C"}
                        loading={this.state.showUserDetailModal}
                        isMulti={true}
                    />
                ) : null}

                {/*need to send pdf in byte string to modal */}
                <PDFModal show={this.state.isModalOpen} onHide={this.closeModal} pdfByteString={this.state.pdfByte} pdfName={this.state.pdfName} />

                {this.state.showSuccessSnackbar ? (
                    <CommonSnackbar
                        show={true}
                        message={this.state.successMessage}
                        variant={this.state.snackbarVariant}
                        autoHide={Constants.SnackBarCloseTimer}
                        title={this.state.snackbarVariant === "success" ? "Success" : "Failed"}
                        handleClose={() => this.setState({ showSuccessSnackbar: false })}
                    />
                ) : <div />
                }

                {this.state.warning ? (
                    <CommonSnackbar
                        show={true}
                        message={this.state.warningmessage}
                        variant={"warning"}
                        autoHide={false}
                        title={"Warning"}
                        handleClose={() => this.setState({ warning: false })}
                    />
                ) : <div />}
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        gap: "10px",
                        flexWrap: "wrap",
                    }}
                >
                    <Box sx={{ alignSelf: "center" }}>
                        <Typography>Customer Company</Typography>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            maxWidth: "auto",

                        }}
                    >
                        <Box
                            sx={{
                                alignSelf: "center",
                                minWidth: "300px",
                                maxWidth: "370px",
                                display: "inline-flex",
                                alignItems: "center",
                            }}
                        >
                            <Box sx={{ flexGrow: 1 }}>
                                <Select menuPlacement="auto"
                                    blurInputOnSelect={false}
                                    menuPortalTarget={document.body}
                                    styles={Constants.Styles}
                                    closeMenuOnSelect={false}
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.value}
                                    isMulti
                                    options={this.state.user}
                                    value={this.state.selectedUser}
                                    onChange={(selectedUser) => this.setState({ selectedUser: selectedUser })}
                                />
                            </Box>
                            <Tooltip title="View More Data">
                                <span style={{ cursor: "pointer", marginLeft: "15px", marginTop: "0px" }}>
                                    <OpenInNewIcon
                                        fontSize="medium"
                                        color="action"
                                        onClick={() => this.setState({ showUserDetailModal: true })}
                                    />
                                </span>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            width: "300px", display: "flex", flexDirection: "row", justifyContent: "space-between",
                            "& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                                height: "2.4rem",
                            },
                            "& .css-wb57ya-MuiFormControl-root-MuiTextField-root": {
                                marginTop: 0,
                            }

                        }}
                        display={"flex"} gap="15px" mt={2} mb={1}>
                        <Typography mt={1}>From</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="picker"
                                ampm={true}
                                renderInput={(props) => (
                                    <TextField
                                        fullWidth
                                        {...props}
                                        inputProps={{ ...props.inputProps, readOnly: true }}
                                    />
                                )}
                                value={this.state.fromDate}
                                inputFormat="DD/MM/YYYY"
                                onChange={(newValue) => {
                                    // Get the current time
                                    const now = dayjs();

                                    // Set startOfMonth to the first day of the selected month, but with the current system time
                                    const fromDate = dayjs(newValue)
                                        .hour(now.hour())
                                        .minute(now.minute())
                                        .second(now.second())
                                        .millisecond(now.millisecond())
                                        .toDate();

                                    this.setState({ fromDate: fromDate })
                                }}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box
                        sx={{
                            width: "300px", display: "flex", flexDirection: "row", justifyContent: "space-between",
                            "& .css-154xyx0-MuiInputBase-root-MuiOutlinedInput-root": {
                                height: "2.5rem",
                            },
                            "& .css-wb57ya-MuiFormControl-root-MuiTextField-root": {
                                marginTop: 0,
                            }

                        }}
                        display={"flex"} gap="15px" mt={2} mb={1}>
                        {" "}
                        <Typography mt={1}>To</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                className="picker"
                                ampm={true}
                                renderInput={(props) => (
                                    <TextField
                                        fullWidth
                                        {...props}
                                        inputProps={{ ...props.inputProps, readOnly: true }}
                                    />
                                )}
                                error={false}
                                value={this.state.toDate}
                                inputFormat="DD/MM/YYYY"
                                onChange={(newValue) => {
                                    // Get the current time
                                    const now = dayjs();

                                    // Set startOfMonth to the first day of the selected month, but with the current system time
                                    const toDate = dayjs(newValue)
                                        .hour(now.hour())
                                        .minute(now.minute())
                                        .second(now.second())
                                        .millisecond(now.millisecond())
                                        .toDate();

                                    this.setState({ toDate: toDate })
                                }}
                            />
                        </LocalizationProvider>
                    </Box>
                    <Box>
                        <TextField

                            margin="normal"
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    padding: "9px 14px !important"
                                },
                                width: "20rem",

                            }}

                            multiline
                            rows={1}
                            placeholder="Enter stone or certificate Id"
                            value={this.state.data}
                            onChange={(e) => {

                                this.setState({
                                    data: Utility.ConvertNewLineToComma(e.target.value)
                                });
                            }}
                        />
                    </Box>
                    <Box sx={{ mt: 2, ml: 2, mb: 1 }}>
                        <LoadingButton
                            loading={this.state.invoiceLoading}
                            loadingPosition="start"
                            disabled={!this.state.user || this.state.user.length === 0}
                            variant="contained"
                            onClick={() => this.handleSearch()}
                            startIcon={<SearchOutlinedIcon size="large" />}
                        >
                            Search
                        </LoadingButton>
                    </Box>
                </Box>

                <ThemeProvider theme={this.defaultMaterialTheme}>
                    <Box
                        sx={{
                            backgroundColor: '#fff',
                            color: '#000',
                            width: "100%",
                            position: "relative",
                            "& .MuiTablePagination-selectLabel": {
                                marginTop: "15px",
                            },
                            "& .MuiTablePagination-displayedRows": {
                                marginTop: "15px",
                            },
                            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .css-cc8tf1": {
                                fontWeight: Constants.defaultFontWeight,
                            },
                            "& .lavenderCell": {
                                color: "#080808",
                                backgroundColor: "#D8BFD8",
                            },
                            height: "78vh",
                        }}
                    >
                        <StyledDataGrid
                            rowHeight={65}
                            disableRowSelectionOnClick={true}
                            density="compact"
                            columns={this.initialColumns()}
                            rows={this.state.invoice}
                            sx={{
                                '& .MuiDataGrid-columnHeader': {
                                    color: '#fff',
                                    backgroundColor: 'grey',
                                },
                                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                    py: "4px",
                                },
                                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                    py: "12px",
                                },
                                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                    py: "18px",
                                },

                                '& .MuiDataGrid-row': {
                                    whiteSpace: 'nowrap',
                                },
                                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                            }}
                            slots={{ toolbar: CustomToolbar }}
                            slotProps={{
                                toolbar: {
                                    showQuickFilter: true,
                                    quickFilterProps: { debounceMs: 500 },
                                },
                            }}
                            getRowId={(row) => row.id}
                            initialState={{
                                pagination: {
                                    paginationModel: Constants.pageSize,
                                },
                            }}
                            sortModel={[
                                {
                                    field: 'id',
                                    sort: 'desc',
                                },
                            ]}
                            getRowClassName={(params) => {
                                if (params.row.status === 'PAID') {
                                    return 'super-app-theme--Paid';
                                } else if (params.row.amountpaid > 0) {
                                    return 'super-app-theme--PartiallyPaid';
                                } else {
                                    return 'super-app-theme--Unpaid';
                                }
                            }}
                            pageSizeOptions={Constants.pageSizeOptions}
                            pagination
                            getDetailPanelHeight={this.getDetailPanelHeight}
                            getDetailPanelContent={({ row }) => this.getDetailPanelContent(row)}
                        />
                    </Box>
                </ThemeProvider>
            </div >
        );
    }
}   